import {
  Component,
  computed,
  input,
  OnInit,
  output,
  viewChild,
} from '@angular/core';
import { BaseComponent } from '@shared/classes';
import { SliderItemType, SliderVariants } from '@shared/constants';
import { Reward } from '@shared/factory';
import { AnyChallenge, CarouselStepContent } from '@shared/models';

import { DefaultSliderComponent } from './default/default.component';
import { FreeModeSliderComponent } from './free-mode/free-mode.component';

export type SliderItems<T extends SliderVariants> =
  T extends SliderVariants.DEFAULT
    ? CarouselStepContent[]
    : (AnyChallenge | Reward)[];

@Component({
  selector: 'b2c-slider',
  templateUrl: './slider.component.html',
  imports: [DefaultSliderComponent, FreeModeSliderComponent],
})
export class SliderComponent extends BaseComponent implements OnInit {
  items = input.required<SliderItems<SliderVariants>>();
  variant = input.required<SliderVariants>();

  itemType = input<SliderItemType>(); // required only for FREE_MODE, can be undefined for DEFAULT

  defaultItems = computed<CarouselStepContent[]>(() =>
    this.variant() === SliderVariants.DEFAULT
      ? (this.items() as CarouselStepContent[])
      : []
  );
  freeModeItems = computed<(AnyChallenge | Reward)[]>(() =>
    this.variant() === SliderVariants.FREE_MODE
      ? (this.items() as (AnyChallenge | Reward)[])
      : []
  );

  indexChange = output<{
    index: number;
    maxIndex: number;
    visibleSlides: number;
    visibleSlidesRaw: number;
  }>();

  freeModeSlider = viewChild<FreeModeSliderComponent>('freeModeSlider');

  readonly SliderVariants: typeof SliderVariants = SliderVariants;

  ngOnInit(): void {
    if (
      this.variant() === SliderVariants.FREE_MODE &&
      this.itemType() === undefined
    ) {
      console.error(
        'SliderComponent: itemType is required when variant is FREE_MODE'
      );
    }
  }
  next(): void {
    this.freeModeSlider()?.next();
  }

  prev(): void {
    this.freeModeSlider()?.prev();
  }

  onIndexChange(payload: {
    index: number;
    maxIndex: number;
    visibleSlides: number;
    visibleSlidesRaw: number;
  }): void {
    this.indexChange.emit(payload);
  }
}
